// extracted by mini-css-extract-plugin
export default {"city":"aC1XFd","external":"bC1XFd","region":"cC1XFd","list":"dC1XFd","name":"eC1XFd"};